module.exports = __webpack_public_path__ + "static/media/AH.8363501b.svg";